export const DEFAULT_SECTION_TEXT =
  'Отправьте заявку, мы\u00A0перезвоним и\u00A0бесплатно проконсультируем, а\u00A0также рассчитаем примерную стоимость';
